// Taboola defaults for both rugby and cricket, all editions.
//
// Notes:
// 1. 'scoreboard' => 'scores'
// 2. 'table' => 'standings'

export default {
  'enabled': true,
  'publisher': 'espn-network',
  'type': 'other',
  'mode': 'thumbnails-3x2-a',
  'container': 'taboola-below-content-thumbnails',
  'target_type': 'mix',
  'schedule': {
    'type': 'other',
    'mode': 'thumbnails-3x2-a',
    'container': 'taboola-below-content-thumbnails',
    'target_type': 'mix'
  },
  'scoreboard': {
    'type': 'other',
    'mode': 'thumbnails-3x2-a',
    'container': 'taboola-below-content-thumbnails',
    'target_type': 'mix'
  },
  'scores': {
    'type': 'other',
    'mode': 'thumbnails-3x2-a',
    'container': 'taboola-below-content-thumbnails',
    'target_type': 'mix'
  },
  'standings': {
    'type': 'other',
    'mode': 'thumbnails-3x2-a',
    'container': 'taboola-below-content-thumbnails',
    'target_type': 'mix'
  },
  'table': {
    'type': 'other',
    'mode': 'thumbnails-3x2-a',
    'container': 'taboola-below-content-thumbnails',
    'target_type': 'mix'
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/taboolaDefaults.js